import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Api } from '@ClientServices/api';
import * as style from './GoToEmburse.styl';
export const componentName = 'GoToEmburse';
export class GoToEmburse extends React.Component {
    constructor() {
        super(...arguments);
        this.samlResponseInputRef = React.createRef();
        this.relayStateInputRef = React.createRef();
        this.samlResponseFormRef = React.createRef();
    }
    handleChange(path) {
        Api.get(`/api/web/saml/emburse/assertion/${this.props.programId}`)
            .then((data) => data.json())
            .then((data) => {
            const base64EncodedAssertion = new Buffer(data.assertionResponse).toString('base64');
            let base64EncodedRelayState = null;
            if (path) {
                base64EncodedRelayState = new Buffer(`{"next": "${path}"}`).toString('base64');
            }
            this.submitForm(base64EncodedAssertion, base64EncodedRelayState, data.acsUrl);
        });
    }
    submitForm(assertion, relayState, acsUrl) {
        this.samlResponseInputRef.current.value = assertion;
        this.relayStateInputRef.current.value = relayState;
        this.samlResponseFormRef.current.action = acsUrl;
        this.samlResponseFormRef.current.submit();
    }
    componentDidMount() {
        if (this.props.autoClick) {
            this.props.samlResponse
                ? this.submitForm(this.props.samlResponse, this.props.relayState, this.props.acsUrl)
                : this.handleChange(this.props.path);
        }
    }
    render() {
        const { path, label } = this.props;
        return (_jsxs("div", Object.assign({ className: `emburse-option ${style.global} ${this.props.autoClick ? 'hidden' : ''}`, onClick: () => this.handleChange(path) }, { children: [_jsxs("form", Object.assign({ ref: this.samlResponseFormRef, action: "", method: "post", target: this.props.target }, { children: [_jsx("input", { ref: this.samlResponseInputRef, type: "hidden", name: "SAMLResponse" }), _jsx("input", { ref: this.relayStateInputRef, type: "hidden", name: "RelayState" })] })), label] })));
    }
}
GoToEmburse.defaultProps = {
    relayState: ''
};
